module.exports = __webpack_public_path__ + "static/media/fresh_back.3d2ffd3d.jpg";